import {
  Collapse,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import useStyles from './useStyles';

export const ListItemLink = (props) => {
  const classes = useStyles();
  return (
    <ListItem
      button
      className={classes.nested}
      to={props.href}
      component={Link}
    >
      <ListItemIcon>{props.children}</ListItemIcon>
      <ListItemText primary={props.text} />
    </ListItem>
  );
};

export const Group = ({items, title, icon, key}) => {
  const [open, setOpen] = useState(false);
  return (
    <div key={key}>
      <ListItem button onClick={() => setOpen(!open)}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={i18n2._(title)} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {items}
      </Collapse>
    </div>
  );
};

// Esta funcion recorre una lista de rutas y por cada una los transforma al item necesario y lo devuelve en la lista 'pusheable' recibida
// Usado: ListItem [Material UI]
const extractAppLinks = (routes, pusheable, key, role) => {
  routes.forEach((route) => {
    if (route.role && route.role.includes(role)) {
      if (route.group) {
        const subItems = displayLinks(route.items, role);
        pusheable.push(
          <Group
            key={key++}
            items={subItems}
            title={route.group}
            icon={route.iconGroup}
          />,
        );
      } else if (route.menuProps) {
        pusheable.push(
          <ListItemLink
            key={key++}
            text={i18n2._(route.menuProps.title)}
            href={'/' + route.path}
          >
            {route.menuProps.icon}
          </ListItemLink>,
        );
      }
    }
  });
};

// Esta funcion crea la lista en donde se cargaran los links.
// Se llama recursivamente si es que se necesita una nueva lista, por ejemplo, para un grupo nuevo
export const displayLinks = (routes, role) => {
  const appLinks = [];
  const key = 0;
  extractAppLinks(routes, appLinks, key, role);
  return appLinks;
};

export default displayLinks;
